import { render, staticRenderFns } from "./DataVolumeByRegion.vue?vue&type=template&id=fd1f4542"
import script from "./DataVolumeByRegion.vue?vue&type=script&lang=js"
export * from "./DataVolumeByRegion.vue?vue&type=script&lang=js"
import style0 from "./DataVolumeByRegion.vue?vue&type=style&index=0&id=fd1f4542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports